import { trace, context, Tracer } from "@opentelemetry/api";

export const TracingComponent = {
    name: "rtcutils-core",
    version: "2.0"
};

export class TracingManager {
    private static instance: TracingManager;
    private tracer: Tracer;

    private constructor() {
        this.tracer = trace.getTracer("gfn-web-gamestream", "2.0");
    }
    public static getInstance(): TracingManager {
        if (!TracingManager.instance) {
            TracingManager.instance = new TracingManager();
        }
        return TracingManager.instance;
    }

    public createSpan<T>(operationName: string, fn: () => Promise<T> | T): Promise<T> {
        const span = this.tracer.startSpan(operationName);
        const wrapper = async () => {
            try {
                const result = fn();
                if (result instanceof Promise) {
                    return await result;
                }
                return result;
            } finally {
                span.end();
            }
        };
        return context.with(trace.setSpan(context.active(), span), wrapper);
    }
}
